import tabNav from './tavNav'
export default tabNav
